import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, change } from 'redux-form';
import {
  Form,
  Grid,
  Button,
  Tab,
  Divider,
  Responsive,
  Icon,
} from 'semantic-ui-react';

import { TitledCard } from 'Components';
import {
  InputField,
  SelectField,
  TextAreaField,
  Toggle,
  DropzoneImage,
} from 'Common/SemanticWrapper';
import { EDIT_INGREDIENT_FORM_NAME } from 'Common/FormEnum';
import Allergens from 'Common/Components/Allergens/Allergens';
import Attributes from 'Common/Components/Attributes/Attributes';
import { NutritionalFacts } from 'Common/Components/NutritionalFacts/NutritionalFacts';
import {
  EditIngredientFieldEnum as Fields,
  NutritionFactFieldEnum as NutritionFactFields,
  NutrientsFieldEnum as NutrientsFields,
  IngMeasurementsFieldEnum as IngMeasurementFields,
} from 'Common/FieldEnum';
import { isValidURL, scrollOnSubmitFail } from 'Common/FormHelper';
import { NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';
import { setNotificationDialog } from 'Components/dialogs/state/actions';
import { MealComponent } from 'Common/Components/MealComponent/MealComponent';
import {
  convertToGrams,
  computeCostPerServing,
} from 'Pages/manageingredient/helpers/ingredient';
import { addVegetables } from 'Pages/managerecipe/helpers/recipe';
import { COMPONENT_TYPE } from 'Common/Components/NutritionalHover/constants/constants';
import { hasWholeValue } from 'Common/Components/NutritionalHover/helpers/helpers';

import * as Selectors from '../../state/editingredient/selectors';

class EditIngredientForm extends Component {
  handleToggleActive = (e, data) => {
    const { dispatch } = this.props;
    let message = NOTIFICATION_DIALOG_MESSAGES.INGREDIENT_ACTIVE;

    if (data.checked) {
      message = NOTIFICATION_DIALOG_MESSAGES.INGREDIENT_INACTIVE;
    }

    dispatch(
      setNotificationDialog({
        ...message,
        actionsToDispatchOnOk: [
          change(EDIT_INGREDIENT_FORM_NAME, Fields.Inactive, data.checked),
        ],
      })
    );
  };

  NutritionFacts = () => {
    const { formValues, touch } = this.props;
    //Need to do this so that errors will show properly since
    //these fields affect each other and can cause an error to show on the other
    //if one is changed
    touch(NutrientsFields.SaturatedFat);
    const totalVeg = addVegetables(formValues);
    const data = {
      ...formValues,
      [Fields.TotalVeg]: totalVeg,
    };

    return (
      <Grid className="nutrition-facts-tab-container">
        <Grid.Column
          mobile={8}
          tablet={8}
          computer={8}
          largeScreen={8}
          widescreen={6}
        >
          <TitledCard title="Nutrition Fact Label">
            <div className="nutrition-facts-container">
              <NutritionalFacts
                data={formValues}
                editable={!this.isReadOnly()}
                formName={EDIT_INGREDIENT_FORM_NAME}
              />
            </div>
          </TitledCard>
        </Grid.Column>
        <Grid.Column
          mobile={8}
          tablet={8}
          computer={8}
          largeScreen={8}
          widescreen={4}
        >
          <TitledCard title="Meal Component">
            <div className="meal-component-container">
              <MealComponent
                formName={EDIT_INGREDIENT_FORM_NAME}
                data={data}
                isReadOnly={this.isReadOnly('MealComponent')}
              />
            </div>
          </TitledCard>
        </Grid.Column>
        <Grid.Column
          mobile={8}
          tablet={8}
          computer={8}
          largeScreen={8}
          widescreen={3}
        >
          <TitledCard title="Allergens">
            <Allergens
              {...this.props}
              formName={EDIT_INGREDIENT_FORM_NAME}
              isReadOnly={this.isReadOnly('Allergens')}
            />
          </TitledCard>
        </Grid.Column>
        <Grid.Column
          mobile={8}
          tablet={8}
          computer={8}
          largeScreen={8}
          widescreen={3}
        >
          <TitledCard title="Attributes">
            <Attributes
              {...this.props}
              formName={EDIT_INGREDIENT_FORM_NAME}
              isReadOnly={this.isReadOnly('Attributes')}
            />
          </TitledCard>
        </Grid.Column>
      </Grid>
    );
  };

  tabPanes = [
    {
      menuItem: 'Nutrition Facts',
      render: () => {
        const { NutritionFacts } = this;
        return (
          <Tab.Pane>
            <NutritionFacts />
          </Tab.Pane>
        );
      },
    },
    {
      menuItem: 'Ingredients (From Product Label)',
      render: () => (
        <Tab.Pane>
          <Field
            className="ing-tab-textarea"
            name={Fields.ProductLabel}
            component={TextAreaField}
            maxLength={1000}
            placeholder="Please type the ingredients found on the product label here."
            disabled={this.isReadOnly()}
          />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Storage',
      render: () => (
        <Tab.Pane>
          <Field
            className="ing-tab-textarea"
            name={Fields.StorageInstructions}
            component={TextAreaField}
            maxLength={1000}
            placeholder="Please type the instructions for storing the ingredient here."
            disabled={this.isReadOnly()}
          />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Preparation',
      render: () => (
        <Tab.Pane>
          <Field
            className="ing-tab-textarea"
            name={Fields.PreparationInstructions}
            component={TextAreaField}
            maxLength={1000}
            placeholder="Please type the instructions for preparing the ingredient here."
            disabled={this.isReadOnly()}
          />
        </Tab.Pane>
      ),
    },
  ];

  renderMeasurementsAndPurchaseData() {
    const { measures, purchasingUnit, packSize, packWeight, costPerGram } =
      this.props;

    const measuresContent = measures.map((m, i) => {
      const measureUnit = m[IngMeasurementFields.BaseMeasure];
      const weightInGrams = convertToGrams(m.Weight, measureUnit);
      const costPerServing = computeCostPerServing(costPerGram, weightInGrams);
      const isDefault = m[IngMeasurementFields.IsDefault];

      return (
        <Grid.Row key={i} textAlign="center">
          <Grid.Column width={2}>
            {isDefault && <Icon className="check" color="green" />}
          </Grid.Column>
          <Grid.Column width={5}>
            {m[IngMeasurementFields.Amount]}{' '}
            {m[IngMeasurementFields.Measurement]}
          </Grid.Column>
          <Grid.Column width={5}>
            {m[IngMeasurementFields.Weight]}{' '}
            {m[IngMeasurementFields.BaseMeasure]}
          </Grid.Column>
          <Grid.Column width={4}>${costPerServing}</Grid.Column>
        </Grid.Row>
      );
    });

    const hasPurchasingContent = Boolean(
      purchasingUnit || packSize || packWeight
    );

    return (
      <Grid>
        {measuresContent.length > 0 ? (
          <Fragment>
            <Grid.Row className="weights-measures-labels" textAlign="center">
              <Grid.Column width={2}>Default</Grid.Column>
              <Grid.Column width={5}>Serving Size</Grid.Column>
              <Grid.Column width={5}>Serving Weight</Grid.Column>
              <Grid.Column width={4}>Cost Per Serving</Grid.Column>
            </Grid.Row>
            {measuresContent}
          </Fragment>
        ) : (
          <Grid.Row>
            <Grid.Column>No measurement data to display.</Grid.Column>
          </Grid.Row>
        )}
        <Divider />
        {hasPurchasingContent ? (
          <Fragment>
            <Grid.Row className="weights-measures-labels" textAlign="center">
              <Grid.Column width={2} />
              <Grid.Column width={5}>Purchasing Unit</Grid.Column>
              <Grid.Column width={5}>Pack Size</Grid.Column>
              <Grid.Column width={4}>Pack Weight</Grid.Column>
            </Grid.Row>
            <Grid.Row textAlign="center">
              <Grid.Column width={2} />
              <Grid.Column width={5}>{purchasingUnit}</Grid.Column>
              <Grid.Column width={5}>{packSize}</Grid.Column>
              <Grid.Column width={4}>{packWeight}</Grid.Column>
            </Grid.Row>
          </Fragment>
        ) : (
          <Grid.Row>
            <Grid.Column>No purchasing data to display.</Grid.Column>
          </Grid.Row>
        )}
      </Grid>
    );
  }

  renderIngredientForm() {
    const {
      formValues,
      ingredientSourcesOptions,
      ingredientGroupsOptions,
      fetchingSources,
      fetchingGroups,
      isUSDAIngredient,
      isDuplicate,
    } = this.props;

    let CNCode = null;

    if (formValues[Fields.CNCode]) {
      CNCode = `ID/CN Code: ${formValues[Fields.CNCode]}`;
    }

    const manufactURLSourceDataColWidth = isUSDAIngredient ? 10 : 8;
    return (
      <TitledCard>
        <Grid>
          <Grid.Row>
            <Grid.Column width={12}>{CNCode}</Grid.Column>
            <Grid.Column width={4} textAlign="right">
              <Button disabled={this.isReadOnly()}>Quick Add</Button>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns="equal">
            <Grid.Column>
              <Field
                component={InputField}
                label="Ingredient Name"
                fluid
                name={Fields.Description}
                maxLength={275}
                disabled={this.isReadOnly(Fields.Description)}
                hideEmptyError
                showOnlyTouchedError
                autoFocus={isDuplicate ? true : false}
              />
            </Grid.Column>
            <Grid.Column width={6}>
              <Field
                component={SelectField}
                label="Source"
                name={Fields.SourceDesc}
                options={ingredientSourcesOptions}
                onChange={this.onIngredientSourceChange}
                loading={fetchingSources}
                disabled={this.isReadOnly(Fields.SourceDesc)}
                fluid
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns="equal">
            <Grid.Column>
              <Field
                component={InputField}
                label="Distributor Code"
                name={Fields.DistributorCode}
                maxLength={50}
                disabled={this.isReadOnly(Fields.DistributorCode)}
                hideEmptyError
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                component={InputField}
                label="GTIN / UPC Code"
                name={Fields.UniversalProductCode}
                maxLength={50}
                disabled={this.isReadOnly(Fields.UniversalProductCode)}
                hideEmptyError
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                component={SelectField}
                label="Group"
                name={Fields.GroupId}
                options={ingredientGroupsOptions}
                loading={fetchingGroups}
                disabled={this.isReadOnly(Fields.GroupId)}
                fluid
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns="equal">
            <Grid.Column>
              <Field
                component={InputField}
                label="MFR Product Code"
                name={Fields.ManufacturerProductCode}
                maxLength={50}
                disabled={this.isReadOnly(Fields.ManufacturerProductCode)}
                hideEmptyError
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                component={InputField}
                label="MFR Name"
                name={Fields.ManufactName}
                maxLength={100}
                disabled={this.isReadOnly(Fields.ManufactName)}
                hideEmptyError
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                component={InputField}
                label="Brand Name"
                name={Fields.ProductName}
                maxLength={15}
                disabled={this.isReadOnly(Fields.ProductName)}
                hideEmptyError
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            {isUSDAIngredient && (
              <Grid.Column width={6}>
                <Field
                  component={InputField}
                  label="Commodity or Recipe Code"
                  name={Fields.CommodityRecipeCode}
                  maxLength={6}
                  disabled={this.isReadOnly(Fields.CommodityRecipeCode)}
                  hideEmptyError
                />
              </Grid.Column>
            )}
            <Grid.Column width={manufactURLSourceDataColWidth}>
              <Field
                component={InputField}
                label="MFR URL"
                name={Fields.ManufacturerURL}
                maxLength={2000}
                disabled={this.isReadOnly(Fields.ManufacturerURL)}
                hideEmptyError
              />
            </Grid.Column>
            {!isUSDAIngredient && (
              <Grid.Column width={manufactURLSourceDataColWidth}>
                <Field
                  component={InputField}
                  label="Source of Nutrient Data"
                  name={Fields.SourceOfNutrientData}
                  maxLength={100}
                  disabled={this.isReadOnly(Fields.SourceOfNutrientData)}
                  hideEmptyError
                />
              </Grid.Column>
            )}
          </Grid.Row>
        </Grid>
      </TitledCard>
    );
  }

  renderPictureForm() {
    const { formValues, convertIngredientToRecipe, openRecipeModal } =
      this.props;

    const recipeId = formValues[Fields.ConvertedToRecipeId];
    const createdFromRecipeId = formValues[Fields.CreatedFromRecipeId];
    const createdFromRecipeDescription =
      formValues[Fields.CreatedFromRecipeDescription];
    let convertToRecipeText = 'Convert To Recipe';
    if (recipeId) {
      convertToRecipeText = 'View Recipe';
    }

    const recipeButtonClick = recipeId
      ? () => openRecipeModal(recipeId)
      : convertIngredientToRecipe;

    return (
      <TitledCard title={``} headerClass={'title-card-header'}>
        <Grid columns={1}>
          <Grid.Row>
            <Grid.Column width={16}>
              <Field
                displayImage={formValues[Fields.Picture]}
                displayImageName={Fields.Picture}
                component={DropzoneImage}
                name={Fields.PicturePreview}
                alt="Upload Ingredient Image"
                disabled={this.isReadOnly(Fields.Picture)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16} textAlign="center">
              <Field
                component={Toggle}
                name={Fields.Inactive}
                checked={formValues[Fields.Inactive]}
                onClick={this.handleToggleActive}
                label="Inactive"
                disabled={this.isReadOnly(Fields.Inactive)}
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={16} textAlign="center">
              {!createdFromRecipeId && (
                <Button
                  onClick={recipeButtonClick}
                  style={{ marginTop: 14 }}
                  disabled={this.isReadOnly()}
                >
                  {convertToRecipeText}
                </Button>
              )}
              {createdFromRecipeId && (
                <div style={{ paddingTop: 10 }}>
                  Created from recipe: <br />
                  {createdFromRecipeId} - {createdFromRecipeDescription}
                </div>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </TitledCard>
    );
  }

  renderMeasurementsAndPurchasePanel() {
    const { toggleMeasuresAndPurchasesModal } = this.props;

    return (
      <TitledCard
        title="Weights, Measures, Inventory & Purchasing"
        rightItem={
          <Button
            className="weights-measures-btn"
            onClick={() => toggleMeasuresAndPurchasesModal(true)}
          >
            Measurements &amp; Purchasing
          </Button>
        }
      >
        {this.renderMeasurementsAndPurchaseData()}
      </TitledCard>
    );
  }

  isReadOnly(exception = '') {
    const { isReadOnly, isSourceReadOnly, isSubRecipe, isUSDAIngredient } =
      this.props;

    // When the isReadOnly prop is true then there is no exception.
    if (isReadOnly) {
      return true;
    }

    // Some fields are still editable when the source is read only and it's a subRecipe or USDAIngredient.
    const subRecipeExceptions = [
      Fields.Description,
      Fields.GroupId,
      Fields.SourceDesc,
      'MealComponent',
      'Allergens',
      'Attributes',
    ];

    const usdaExceptions = ['MealComponent', 'Allergens', 'Attributes'];

    if (isSourceReadOnly) {
      if (isUSDAIngredient) {
        return usdaExceptions.includes(exception) ? false : true;
      }

      return isSubRecipe && subRecipeExceptions.includes(exception)
        ? false
        : true;
    }

    return false;
  }

  render() {
    return (
      <Form>
        <Grid>
          <Responsive as={Grid.Row} maxWidth={1480}>
            <Grid.Column width={12}>{this.renderIngredientForm()}</Grid.Column>
            <Grid.Column width={4}>{this.renderPictureForm()}</Grid.Column>
          </Responsive>
          <Responsive as={Grid.Row} minWidth={1481}>
            <Grid.Column width={7}>{this.renderIngredientForm()}</Grid.Column>
            <Grid.Column width={6}>
              {this.renderMeasurementsAndPurchasePanel()}
            </Grid.Column>
            <Grid.Column width={3}>{this.renderPictureForm()}</Grid.Column>
          </Responsive>
          <Responsive as={Grid.Row} maxWidth={1480}>
            <Grid.Column>
              {this.renderMeasurementsAndPurchasePanel()}
            </Grid.Column>
          </Responsive>
        </Grid>
        <Grid columns={1} className="tabs-container">
          <Grid.Row>
            <Grid.Column>
              <Tab
                menu={{
                  color: 'blue',
                  inverted: true,
                  attached: true,
                }}
                panes={this.tabPanes}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

const validate = (values) => {
  const errors = {};

  if (!values[Fields.Description] || !values[Fields.Description].trim()) {
    errors[Fields.Description] = 'Field is required.';
  }

  if (
    values[Fields.ManufacturerURL] &&
    !isValidURL(values[Fields.ManufacturerURL])
  ) {
    errors[Fields.ManufacturerURL] = 'URL is invalid.';
  }

  if (
    !values[NutritionFactFields.BaseWeight] ||
    !values[NutritionFactFields.BaseWeight].trim()
  ) {
    errors[NutritionFactFields.BaseWeight] = 'Required';
  }

  if (!values[NutritionFactFields.BaseWeightOGL]) {
    errors[NutritionFactFields.BaseWeightOGL] = 'Required';
  }


  const saturatedFatIsAnNumber =
    !Number.isNaN(Number.parseFloat(values[NutrientsFields.SaturatedFat])) &&
    Number.parseFloat(values[NutrientsFields.SaturatedFat]) > 0;

  const saturatedFat = saturatedFatIsAnNumber
    ? Number.parseFloat(values[NutrientsFields.SaturatedFat])
    : 0;
  const totalFat = Number.parseFloat(values[NutrientsFields.TotalFat]);
  if (saturatedFatIsAnNumber && saturatedFat > totalFat) {
    errors[
      NutrientsFields.SaturatedFat
    ] = `Saturated Fat cannot be greater than Total Fat`;
  }

  return errors;
};

const onChange = (values, dispatch, props, previousValues) => {
  if (values && previousValues && Object.keys(previousValues).length) {
    const totalVeg = addVegetables(values);
    dispatch(change(EDIT_INGREDIENT_FORM_NAME, Fields.TotalVeg, totalVeg));

    if (
      !hasWholeValue(values[Fields.Fruit]) &&
      totalVeg === 0 &&
      values[Fields.ComponentType] === COMPONENT_TYPE.Juice
    ) {
      dispatch(
        change(
          EDIT_INGREDIENT_FORM_NAME,
          Fields.ComponentType,
          COMPONENT_TYPE.None
        )
      );
    }

    if (!hasWholeValue(values[Fields.Milk])) {
      dispatch(
        change(EDIT_INGREDIENT_FORM_NAME, Fields.Milk_LowFatFlavored, false)
      );
      dispatch(
        change(EDIT_INGREDIENT_FORM_NAME, Fields.Milk_LowFatUnflavored, false)
      );
      dispatch(
        change(
          EDIT_INGREDIENT_FORM_NAME,
          Fields.Milk_ReducedWholeUnflavoredFlavored,
          false
        )
      );
      dispatch(
        change(EDIT_INGREDIENT_FORM_NAME, Fields.Milk_SkimFlavored, false)
      );
      dispatch(
        change(EDIT_INGREDIENT_FORM_NAME, Fields.Milk_SkimUnflavored, false)
      );
    }
  }
};

const mapStateToProps = (state) => ({
  measures: Selectors.getMeasuresToDisplay(state),
  purchasingUnit: Selectors.getPurchasingUnit(state),
  packSize: Selectors.getPackSize(state),
  packWeight: Selectors.getPackWeight(state),
  costPerGram: Selectors.getCostPerGram(state),
  isReadOnly: Selectors.getIsReadOnly(state),
  isSourceReadOnly: Selectors.getIsSourceReadOnly(state),
  isUSDAIngredient: Selectors.getIsUSDAIngredient(state),
});

EditIngredientForm = connect(mapStateToProps)(
  reduxForm({
    form: EDIT_INGREDIENT_FORM_NAME,
    destroyOnUnmount: false,
    validate,
    onChange,
    onSubmitFail: scrollOnSubmitFail(),
  })(EditIngredientForm)
);

export { EditIngredientForm };



// WEBPACK FOOTER //
// ./src/pages/manageingredient/subpages/editingredient/EditIngredientForm.js